import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    Label,
    Input,
    FormGroup,
    Form,
    Col,
    Row,
    Collapse,
    Popover,
    PopoverBody, Modal, ModalBody
} from 'reactstrap';
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import './CredentialsVerificationRequest.css';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {
    REQUEST_EMAIL_SOURCE_DEPARTMENT, REQUEST_EMAIL_SOURCE_NONE,
    REQUEST_EMAIL_SOURCE_REQUESTER
} from "../../../constants/constants";
import ConsentRequestBulkDropZone from "./consentRequestBulkDropZone/ConsentRequestBulkDropZone.container";
import IconContainer from "../../commonComponents/iconContainer/IconContainer";
import {Link} from "react-router-dom";
import Select from "../../commonComponents/customSelect/CustomSelect.container";

class CredentialsVerificationRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            emails: "",
            emailSource: REQUEST_EMAIL_SOURCE_REQUESTER,
            hideName: false,
            jobInternalReference: "",
            jobTitle: "",
            exposeJobReference: false,
            message: "",
            isOpenModal: false,
            bulkUploadEnabled: false,
            bulkDropZoneError: null,
            cleanDropZoneState: false,
            emailsInfoPopoverOpen: false
        };
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.bulkUploadEnabled && nextState.emails.length !== 0 && nextState.bulkDropZoneError) {
            this.setState({bulkDropZoneError: null});
        }

        if (this.state.cleanDropZoneState) {
            this.setState({cleanDropZoneState: false});
        }

        if (!this.props.success && nextProps.success) {
            this.setState({isOpenModal: true});
            this.resetData();
        }
    }

    render() {
        if (this.props.loading || _.isNil(this.props.operationAvailability)) {
            return (
                <div className="credentials-verification-request-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        return (
            <div className="request-credentials-verification-container">
                <FormWrapper showSuccessAlert={false}>
                    <div className="request-credentials-verification-form">
                        <h4 className="text-center">{_.get(this.props.translation, 'request_credentials_verification.label')}</h4>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
                {this.renderSuccessModal()}
            </div>
        );
    }

    renderContent = () => {
        if (this.props.operationAvailability && !this.props.operationAvailability.canCreateConsentRequest) {
            return (
                <div className="credentials-verification-request-status-message-container">
                    <h6>{_.get(this.props.translation, 'request_credentials_verification.request_unavailable_alert')}</h6>
                </div>
            );
        }

        return (
            <Form onSubmit={this.onSubmit}>
                {this.renderDepartmentFormGroup()}
                <h5 className='request-credentials-verification-subtitle olive-green'>{_.get(this.props.translation, 'request_credentials_verification.your_data_label')}</h5>
                <FormGroup>
                    <div className='request_credentials_verification-message'>
                        {_.get(this.props.translation, 'request_credentials_verification.visible_data_message')}
                    </div>
                    {this.renderYourEmailFormGroup()}
                    {this.renderCompanyDataRow()}
                    {this.renderYourNameRow()}
                    {this.renderCheckBoxes()}
                </FormGroup>
                <FormGroup>
                    <h5 className='request-credentials-verification-subtitle olive-green'>{_.get(this.props.translation, 'request_credentials_verification.applicant_data_label')}</h5>
                    <div className='request_credentials_verification-message'>
                        {_.get(this.props.translation, 'request_credentials_verification.reference_to_bulk_list_start')}
                        <Link to='/bulk-consent-requests' target="_blank">
                            {_.get(this.props.translation, 'request_credentials_verification.reference_to_bulk_list_link')}
                        </Link>
                        {_.get(this.props.translation, 'request_credentials_verification.reference_to_bulk_list_end')}
                    </div>
                    {this.renderApplicantIdentityFormGroups()}
                </FormGroup>
                <FormGroup>
                    <h5 className='request-credentials-verification-subtitle olive-green'>{_.get(this.props.translation, 'request_credentials_verification.reason_for_request_label')}</h5>
                    {this.renderJobFormGroups()}
                    <FormGroup className="request-message-container">
                        <Label>{_.get(this.props.translation, 'consents.note_to_applicants_label')}</Label>
                        <Input type="textarea"
                               value={this.state.message}
                               onChange={this.handleChange("message")}
                               placeholder={_.get(this.props.translation, 'request_credentials_verification.reason_for_request_placeholder')}
                        />
                    </FormGroup>
                </FormGroup>

                <div className="buttons-group">
                    <Button type="submit"
                            className="olive-green-btn">{_.get(this.props.translation, 'request_credentials_verification.submit_button')}</Button>
                </div>
            </Form>
        )
    };

    renderSuccessModal = () => {
        return (
            <Modal className="request-credentials-verification-modal" isOpen={this.state.isOpenModal}
                   toggle={this.handleStay}>
                <ModalBody>
                    <div>
                        <Label>
                            {_.get(this.props.translation, 'request_credentials_verification.success_modal_label')}
                        </Label>
                        <div className="modal-buttons-container">
                            <Button className="olive-green-btn"
                                    onClick={this.handleStay}>{_.get(this.props.translation, 'request_credentials_verification.stay_on_this_page_label')}</Button>
                            <Button className="olive-green-btn"
                                    tag={Link}
                                    to='/home'>{_.get(this.props.translation, 'request_credentials_verification.go_to_home_page_label')}</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    };

    handleStay = () => {
        this.setState({isOpenModal: false});
    };

    renderDepartmentFormGroup = () => {
        if (this.props.departmentName) {
            return (
                <FormGroup row className="consent-request-department-form-group">
                    <div className="consent-request-department-container">
                        <h6>{_.get(this.props.translation, sharedLabelsPath.department_label)}:</h6>
                        <div>{this.props.departmentName}</div>
                    </div>
                </FormGroup>
            )
        }
    };

    renderApplicantIdentityFormGroups = () => {
        return (
            <div>
                {this.renderInputModeMenu()}
                <Collapse isOpen={!this.state.bulkUploadEnabled}>
                    <FormGroup row className="emails-form-group">
                        <Label for='emails'
                               sm={3}>{_.get(this.props.translation, 'request_credentials_verification.emails_label')}*</Label>
                        <Col sm={8} className="emails-textarea-container">
                            <Input type='textarea' id='emails'
                                   value={this.state.emails}
                                   placeholder={_.get(this.props.translation, 'request_credentials_verification.emails_label')}
                                   required={!this.state.bulkUploadEnabled}
                                   onChange={this.handleChange('emails')}>
                            </Input>
                        </Col>
                        <Col sm={1} id='applicant-emails-icons-container' className="applicant-emails-icons-container">
                            <IconContainer icon="question_mark"
                                           key="applicant-emails-hint-icon"
                                           onClick={this.toggleEmailsInfoPopover}
                                           className="applicant-emails-hint-icon"/>
                        </Col>
                        <Popover placement="top"
                                 isOpen={this.state.emailsInfoPopoverOpen}
                                 key="applicant-emails-hint-popover"
                                 target="applicant-emails-icons-container">
                            <PopoverBody>
                                {_.get(this.props.translation, 'request_credentials_verification.manual_input_hint')}
                            </PopoverBody>
                        </Popover>
                    </FormGroup>
                </Collapse>
                <Collapse isOpen={this.state.bulkUploadEnabled && this.state.emails.length === 0}>
                    <ConsentRequestBulkDropZone onSubmit={this.handleFileUpload}
                                                clean={this.state.cleanDropZoneState}
                                                error={this.state.bulkDropZoneError}/>
                </Collapse>
                <Collapse isOpen={this.state.bulkUploadEnabled && this.state.emails.length !== 0}>
                    <FormGroup className="emails-form-group">
                        <Row>
                            <Label for='uploaded-emails-textarea'
                                   sm={3}>{_.get(this.props.translation, 'bulk_jobs_list.file_name_label')}</Label>
                            <Col sm={8} id="uploaded-file-name">
                                {this.state.fileName}
                            </Col>
                            <Col sm={1} id='applicant-emails-icons-container'
                                 className="applicant-emails-icons-container">
                                <IconContainer icon="clear"
                                               key="applicant-emails-remove-icon"
                                               id="applicant-emails-icon"
                                               className="applicant-emails-remove-icon"
                                               onClick={this.handleEmailsRemove}/>

                            </Col>
                        </Row>
                        <Row>
                            <Label for='uploaded-emails-textarea'
                                   sm={3}>{_.get(this.props.translation, 'request_credentials_verification.emails_label')}</Label>
                            <Col sm={8} className="emails-textarea-container">
                                <Input type='textarea'
                                       id='uploaded-emails-textarea'
                                       className="uploaded-emails-textarea"
                                       disabled
                                       rows={this.state.emails.length > 0 ? (this.state.emails.length > 3 ? 4 : this.state.emails.length) : 1}
                                       value={_.slice(this.state.emails, 0, 3).join('\n') + (this.state.emails.length > 3 ? '\n...' : '')}
                                       placeholder={_.get(this.props.translation, 'request_credentials_verification.emails_label')}>
                                </Input>
                            </Col>
                        </Row>
                    </FormGroup>
                </Collapse>
            </div>
        );
    };

    renderInputModeMenu = () => {
        return (
            <div className="emails-input-mode-menu">
                <div
                    className={"input-mode-icon-container" + (!this.state.bulkUploadEnabled ? " olive-green" : "")}
                    onClick={this.handleToggleBulkUpload(false)}>
                    <IconContainer
                        className="input-mode-icon"
                        icon={"radio_button_" + (!this.state.bulkUploadEnabled ? "checked" : "unchecked")}
                        title={_.get(this.props.translation, 'request_credentials_verification.manual_input_label')}
                    />
                    {_.get(this.props.translation, 'request_credentials_verification.manual_input_label')}
                </div>
                <div
                    className={"input-mode-icon-container" + (this.state.bulkUploadEnabled ? " olive-green" : "")}
                    onClick={this.handleToggleBulkUpload(true)}>
                    <IconContainer
                        className="input-mode-icon"
                        icon={"radio_button_" + (this.state.bulkUploadEnabled ? "checked" : "unchecked")}
                        title={_.get(this.props.translation, 'request_credentials_verification.upload_file_label')}
                    />
                    {_.get(this.props.translation, 'request_credentials_verification.upload_file_label')}
                </div>
            </div>
        )
    };

    toggleEmailsInfoPopover = () => {
        this.setState({emailsInfoPopoverOpen: !this.state.emailsInfoPopoverOpen})
    };

    renderJobFormGroups = () => {
        let jobInternalReferenceParams = {
            value: "jobInternalReference",
            title: _.get(this.props.translation, 'consents.internal_job_reference'),
            placeholder: _.get(this.props.translation, 'consents.internal_job_reference'),
            className: "job-internal-reference-form-group"
        };
        let jobTitleParams = {
            value: "jobTitle",
            title: _.get(this.props.translation, 'consents.job_title_label') + "*",
            isRequired: true,
            placeholder: _.get(this.props.translation, 'consents.job_title_label')
        };
        let exposeJobReferenceParams = {
            checked: this.state.exposeJobReference,
            key: "exposeJobReference",
            title: _.get(this.props.translation, 'consents.expose_job_reference')
        };
        return [
            this.getFormGroup(jobInternalReferenceParams),
            this.getCheckboxFormGroup(exposeJobReferenceParams),
            this.getFormGroup(jobTitleParams)
        ];
    };

    renderYourEmailFormGroup = () => {
        let emailsList = [
            {value: REQUEST_EMAIL_SOURCE_REQUESTER, label: this.props.yourEmail}
        ];

        if (!_.isNil(this.props.departmentEmail)) {
            emailsList.push({value: REQUEST_EMAIL_SOURCE_DEPARTMENT, label: this.props.departmentEmail});
        }
        emailsList.push({
            value: REQUEST_EMAIL_SOURCE_NONE,
            label: _.get(this.props.translation, 'consents.none_label')
        });

        return (
            <FormGroup row key='email-source'>
                <Label for='email-source'
                       sm={3}>{_.get(this.props.translation, sharedLabelsPath.email_label) + '*'}</Label>
                <Col sm={9}>
                    <Select id='email-source'
                            selectedOption={_.find(emailsList, option => option.value === this.state.emailSource)}
                            options={emailsList}
                            onSelect={this.handleEmailSourceChange}
                            placeholder={_.get(this.props.translation, sharedLabelsPath.email_label)}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderYourNameRow = () => {
        let paramsList = [
            {
                value: (this.props.yourName ? this.props.yourName.firstName + ' ' + this.props.yourName.lastName : ''),
                title: _.get(this.props.translation, sharedLabelsPath.name_label),
            }
        ];

        return [..._.map(paramsList, this.getDataRow)];
    };


    renderCheckBoxes = () => {
        let paramsList = [
            {
                checked: this.state.hideName,
                key: "hideName",
                title: _.get(this.props.translation, 'request_credentials_verification.hide_your_name_label')
            }/* Note: disabled in current version,
            {
                checked: this.state.isGetEmail && this.state.yourEmail !== "none",
                key: "isGetEmail",
                disabled: this.state.yourEmail === "none",
                title: _.get(this.props.translation, 'request_credentials_verification.get_email_label')
            }*/
        ];

        return [..._.map(paramsList, this.getCheckboxFormGroup)];
    };

    renderCompanyDataRow = () => {
        let title = _.get(this.props.translation, sharedLabelsPath.company_label);
        let value = (this.props.companyName || '') + ', ' + (_.get(this.props.translation, 'countries.' + this.props.companyCountry) || '');
        return (
            <Row key={title}>
                <Label sm={3}>{title}:</Label>
                <Col sm={9}>{value}</Col>
            </Row>
        );
    };

    getFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }

        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title} className={params.className || ""}>
                <Label for={id} sm={3}>{params.title}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={this.state[params.value]}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                    >
                        {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    getDataRow = params => {
        if (!params || typeof (params) !== 'object') {
            return;
        }

        return (
            <Row key={params.title}>
                <Label sm={3}>{params.title}:</Label>
                <Col sm={9}>{params.value}</Col>
            </Row>
        );
    };

    getCheckboxFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }

        return (
            <FormGroup check key={params.key} className="checkbox-container">
                <Row key={params.title}>
                    <Col/>
                    <Col sm={9}>
                        <Label check>
                            <Input
                                type="checkbox"
                                checked={params.checked}
                                onChange={this.handleChangeCheckbox(params.key)}
                                disabled={params.disabled}
                            />
                            {params.title}
                        </Label>
                    </Col>
                </Row>

            </FormGroup>
        );
    };

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleEmailSourceChange = (selectedOption) => {
        this.setState({emailSource: selectedOption.value});
    };

    handleChangeContinent = (e) => {
        this.setState({
            companyContinent: e.target.value,
            companyCountry: '',
        });
        this.props.onContinentsSet(e.target.value);
    };

    handleChangeCheckbox = (fieldName) => () => {
        this.setState({[fieldName]: !this.state[fieldName]});
    };

    handleFileUpload = (file) => {
        this.setState({bulkDropZoneError: null});
        let fileReader = new FileReader();

        fileReader.onloadend = () => {
            let content = fileReader.result.trim().split(/[\s,;]+/).filter(email => !_.isEmpty(email));
            if (_.isEmpty(content)) {
                this.setState({bulkDropZoneError: _.get(this.props.translation, 'bulk_upload.consent_request_bulk_empty_file_label')})
            } else {
                this.setState({
                    emails: content,
                    fileName: file.name
                });
            }
        };

        fileReader.readAsText(file);
    };

    handleToggleBulkUpload = (enabled) => () => {
        if (this.state.bulkUploadEnabled !== enabled) {
            this.setState({
                bulkUploadEnabled: enabled,
                emails: enabled ? [] : '',
                bulkDropZoneError: false,
                cleanDropZoneState: true,
                emailsInfoPopoverOpen: false
            });
        }
    };

    handleEmailsRemove = () => {
        this.setState({emails: [], cleanDropZoneState: true});
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (this.state.bulkUploadEnabled && this.state.emails.length === 0) {
            this.setState({bulkDropZoneError: _.get(this.props.translation, 'bulk_upload.consent_request_bulk_error_label')});
            return;
        }

        let emails = _.isArray(this.state.emails) ? this.state.emails : this.state.emails.trim().split(/[\s,;]+/).filter(email => !_.isEmpty(email));

        let data = {
            emailSource: this.state.emailSource,
            showRequesterFNLN: !this.state.hideName,
            requestComment: this.state.message,
            departmentId: this.props.departmentId,
            jobDescription: {
                internalReference: (this.state.jobInternalReference !== "") ? this.state.jobInternalReference : null,
                title: this.state.jobTitle,
                exposeReference: this.state.exposeJobReference
            },
            emails: _.uniq(emails.map(email => email.toLowerCase()))
        };

        if (this.state.bulkUploadEnabled || data.emails.length > 1) {
            this.props.onProcessBulkRequest(data);
        } else {
            this.props.onProcessRequest(data);
        }
    };

    resetData = () => {
        this.setState({
            emails: "",
            emailSource: REQUEST_EMAIL_SOURCE_REQUESTER,
            hideName: false,
            jobInternalReference: "",
            jobTitle: "",
            exposeJobReference: false,
            message: "",
            bulkUploadEnabled: false,
            bulkDropZoneError: null,
            cleanDropZoneState: false,
            emailsInfoPopoverOpen: false
        })
    }
}

CredentialsVerificationRequest.propTypes = {
    continents: PropTypes.array,
    countries: PropTypes.array,
    translation: PropTypes.object.isRequired,
    departmentId: PropTypes.string,
    departmentName: PropTypes.string,
    yourEmail: PropTypes.string,
    departmentEmail: PropTypes.string,
    success: PropTypes.bool,
    operationAvailability: PropTypes.object,
    onProcessRequest: PropTypes.func.isRequired,
    onProcessBulkRequest: PropTypes.func.isRequired,
    onContinentsSet: PropTypes.func.isRequired,
    onResetData: PropTypes.func.isRequired
};

export default CredentialsVerificationRequest;



// WEBPACK FOOTER //
// ./src/components/consentManagement/credentialsVerificationRequest/CredentialsVerificationRequest.js